var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _AnxietyFilledJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import JournalEvent from "core/models/journal-event";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import Patient from "./patient";

//---- Automatically generated, don't update this part ----

/**
 * Represents an anxiety survey filled.
 */
let AnxietyFilledJournalEvent = (_dec = attr("number"), _dec2 = attr("number"), _dec3 = attr("number"), _dec4 = attr("number"), _dec5 = attr("number"), _dec6 = attr("number"), _dec7 = attr("number"), _dec8 = attr("number"), _dec9 = attr("number"), _dec10 = attr("number"), _dec11 = attr("number"), _dec12 = attr("number"), _dec13 = attr("number"), _dec14 = attr("number"), _dec15 = attr("number"), _dec16 = attr("number"), _dec17 = attr("number"), _dec18 = attr("number"), _dec19 = attr("number"), _dec20 = attr("number"), _dec21 = attr("string"), _dec22 = attr("number"), _dec23 = belongsTo("patient", {
  async: false,
  inverse: "anxietyFilledJournalEvents"
}), _class = (_AnxietyFilledJournalEvent = class AnxietyFilledJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "willingness", _descriptor, this);
    _initializerDefineProperty(this, "nervous", _descriptor2, this);
    _initializerDefineProperty(this, "happyMyself", _descriptor3, this);
    _initializerDefineProperty(this, "happinessOthers", _descriptor4, this);
    _initializerDefineProperty(this, "fail", _descriptor5, this);
    _initializerDefineProperty(this, "rested", _descriptor6, this);
    _initializerDefineProperty(this, "calm", _descriptor7, this);
    _initializerDefineProperty(this, "overcome", _descriptor8, this);
    _initializerDefineProperty(this, "overreact", _descriptor9, this);
    _initializerDefineProperty(this, "happy", _descriptor10, this);
    _initializerDefineProperty(this, "troubledThoughts", _descriptor11, this);
    _initializerDefineProperty(this, "confidence", _descriptor12, this);
    _initializerDefineProperty(this, "security", _descriptor13, this);
    _initializerDefineProperty(this, "decisions", _descriptor14, this);
    _initializerDefineProperty(this, "equalTo", _descriptor15, this);
    _initializerDefineProperty(this, "satisfaction", _descriptor16, this);
    _initializerDefineProperty(this, "ideasWithoutImportance", _descriptor17, this);
    _initializerDefineProperty(this, "disappointment", _descriptor18, this);
    _initializerDefineProperty(this, "solidNerves", _descriptor19, this);
    _initializerDefineProperty(this, "preoccupied", _descriptor20, this);
    _initializerDefineProperty(this, "originTaskIdentifier", _descriptor21, this);
    _initializerDefineProperty(this, "score", _descriptor22, this);
    _initializerDefineProperty(this, "patient", _descriptor23, this);
  }
  static validations(intl) {
    return {
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.anxiety-filled-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })],
      willingness: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.willingness")
      }),
      nervous: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.nervous")
      }),
      happyMyself: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.happy-myself")
      }),
      happinessOthers: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.happiness-others")
      }),
      fail: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.fail")
      }),
      rested: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.rested")
      }),
      calm: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.calm")
      }),
      overcome: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.overcome")
      }),
      overreact: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.overreact")
      }),
      happy: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.happy")
      }),
      troubledThoughts: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.troubled-thoughts")
      }),
      confidence: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.confidence")
      }),
      security: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.security")
      }),
      decisions: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.decisions")
      }),
      equalTo: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.equal-to")
      }),
      satisfaction: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.satisfaction")
      }),
      ideasWithoutImportance: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.ideas-without-importance")
      }),
      disappointment: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.disappointment")
      }),
      solidNerves: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.solid-nerves")
      }),
      preoccupied: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.preoccupied")
      }),
      score: validateNumber({
        allowBlank: true,
        description: intl.t("validations.anxiety-filled-journal-event.score")
      })
    };
  }

  //---- End of generated code ----
}, _defineProperty(_AnxietyFilledJournalEvent, "type", "anxiety-filled-journal-event"), _defineProperty(_AnxietyFilledJournalEvent, "states", ["willingness", "nervous", "happyMyself", "happinessOthers", "fail", "rested", "calm", "overcome", "overreact", "happy", "troubledThoughts", "confidence", "security", "decisions", "equalTo", "satisfaction", "ideasWithoutImportance", "disappointment", "solidNerves", "preoccupied"]), _AnxietyFilledJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "willingness", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "nervous", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "happyMyself", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "happinessOthers", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "fail", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "rested", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "calm", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "overcome", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "overreact", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "happy", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "troubledThoughts", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "confidence", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "security", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "decisions", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "equalTo", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "satisfaction", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "ideasWithoutImportance", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "disappointment", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "solidNerves", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "preoccupied", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "originTaskIdentifier", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "score", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { AnxietyFilledJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.